import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const CauchyIntegralFormula = () => (
  <QPhototModuleSubtopic
    title="Cauchy Integral formula"
    videos={[
      "https://www.youtube.com/embed/azOay4qEykk",
      "https://www.youtube.com/embed/CApd1dxHK9Q",
      "https://www.youtube.com/embed/8Im1MmO8AY0"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_30.png"},
        {image:"/cvla_31.png"},
        {image:"/cvla_32.png"},
    ]}
    exampleVideos={[]}
  />
);

export default CauchyIntegralFormula;
